var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 7.4H5C6.6 7.4 7.4 6.6 7.4 5V3.4C7.4 1.8 6.6 1 5 1H3.4C1.8 1 1 1.8 1 3.4V5C1 6.6 1.8 7.4 3.4 7.4ZM13 7.4H14.6C16.2 7.4 17 6.6 17 5V3.4C17 1.8 16.2 1 14.6 1H13C11.4 1 10.6 1.8 10.6 3.4V5C10.6 6.6 11.4 7.4 13 7.4ZM13 17H14.6C16.2 17 17 16.2 17 14.6V13C17 11.4 16.2 10.6 14.6 10.6H13C11.4 10.6 10.6 11.4 10.6 13V14.6C10.6 16.2 11.4 17 13 17ZM3.4 17H5C6.6 17 7.4 16.2 7.4 14.6V13C7.4 11.4 6.6 10.6 5 10.6H3.4C1.8 10.6 1 11.4 1 13V14.6C1 16.2 1.8 17 3.4 17Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.3f1ccf78c447415ce632254c34934916.svg";
export { ForwardRef as ReactComponent };